import React, { FC } from 'react';
import { VendorContactPerson } from '../../dto/Vendor';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { Button } from 'antd';
import VendorContactEditModal, {
  useVendorContactEditModal,
} from './VendorContactEditModal';
import {
  DeleteOutlined,
  EditOutlined,
  MailOutlined,
  MobileOutlined,
  PhoneOutlined,
  PlusOutlined,
} from '@ant-design/icons';

type Props = {
  value?: VendorContactPerson[];
  onChange?: (value: VendorContactPerson[]) => void;
};

export const VendorContactsItem: FC<{
  value?: VendorContactPerson;
  onChange?: (value?: VendorContactPerson) => void;
}> = ({ value, onChange }) => {
  const modal = useVendorContactEditModal();
  return (
    <>
      <div
        className="border rounded border-solid border-gray-200 p-2 px-4 relative cursor-pointer hover:border-primary duration-300"
        onClick={() =>
          modal.current
            ?.open(value)
            .then((v) => onChange?.(v))
            .catch((e) => {})
        }
      >
        <div>
          {[value?.salutation, value?.firstName, value?.lastName]
            .filter((v) => !!v)
            .join(' ')}
        </div>
        {(value?.email || value?.phone || value?.mobile) && (
          <div className="flex gap-4 text-gray-500">
            {value?.email && (
              <div className="flex gap-1">
                <MailOutlined />
                {value.email}
              </div>
            )}
            {value?.phone && (
              <div className="flex gap-1">
                <PhoneOutlined />
                {formatPhoneNumberIntl(value.phone)}
              </div>
            )}
            {value?.mobile && (
              <div className="flex gap-1">
                <MobileOutlined />
                {formatPhoneNumberIntl(value.mobile)}
              </div>
            )}
          </div>
        )}
        <div className="absolute top-0 right-0">
          <Button type="link" shape="circle">
            <EditOutlined />
          </Button>
          <Button
            type="link"
            shape="circle"
            danger={true}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onChange?.(undefined);
            }}
          >
            <DeleteOutlined />
          </Button>
        </div>
      </div>
      <VendorContactEditModal ref={modal} />
    </>
  );
};

export const VendorContactsSection: FC<Props> = ({ value, onChange }) => {
  const modal = useVendorContactEditModal();
  return (
    <div className="flex flex-col gap-2">
      {value?.map((v: VendorContactPerson, i) => (
        <VendorContactsItem
          key={i}
          value={v}
          onChange={(v) => {
            const newVal: VendorContactPerson[] = value
              ?.map((val, idx) => (idx === i ? v : val))
              .filter((val) => !!val) as any;
            onChange?.(newVal);
          }}
        />
      ))}
      <Button
        icon={<PlusOutlined />}
        type={'dashed'}
        onClick={() =>
          modal.current
            ?.open()
            .then((val) => onChange?.([...(value ?? []), val]))
            .catch(() => {})
        }
      >
        Add Contact Person
      </Button>
      <VendorContactEditModal ref={modal} />
    </div>
  );
};
